import { render, staticRenderFns } from "./NewHistory.vue?vue&type=template&id=94a2e9e4"
import script from "./NewHistory.vue?vue&type=script&lang=js"
export * from "./NewHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports